import { localPx2rem } from "@mpc/common/src/utils";

export const MULTIPLE_TYPE = {
  multiple: {
    showSelectAllOption: true,
  },
};
export const SELECT_SINGLE_CONFIG = {
  single: { showSelectNoOption: true, selectNoOptionName: '- 全部 -' },
};

export const COMMON_POPUP_PROPS = {
  getPopupContainer: undefined,
  popupStyle: { width: 120 },
};

const FILTER_OPTIONS = {
  principals: {
    mode: 'filter',
    treeCheckable: true,
    isTree: true,
    isMultiple: true,
    searchEnable: true,
    typeConfig: {
      multiple: { showSelectAllOption: true },
    },
    popupProps: {
      getPopupContainer: undefined,
    },
    style: { width: 160 },
  },
  plan_users: {
    mode: 'filter',
    treeCheckable: true,
    isTree: true,
    isMultiple: true,
    searchEnable: true,
    typeConfig: {
      multiple: { showSelectAllOption: true },
    },
    popupProps: {
      getPopupContainer: undefined,
    },
    style: { width: 160 },
  },
  wb_products: {
    mode: 'filter',
    treeCheckable: true,
    isTree: true,
    isMultiple: true,
    searchEnable: true,
    typeConfig: {
      multiple: { showSelectAllOption: true },
    },
    style: { width: 120 },
    popupProps: {
      getPopupContainer: undefined,
      popupStyle: { width: localPx2rem(160) },
    },
  },
  status: {
    mode: 'filter',
    typeConfig: SELECT_SINGLE_CONFIG,
  },
  priorities: {
    mode: 'filter',
    isMultiple: true,
    typeConfig: {
      multiple: { showSelectAllOption: true },
    },
    style: { width: 120 },
  },
  bidding_types: {
    mode: 'filter',
    isMultiple: true,
    typeConfig: {
      multiple: { showSelectAllOption: true },
    },
    style: { width: 120 },
  },
  bidding_methods: {
    mode: 'filter',
    isMultiple: true,
    typeConfig: {
      multiple: { showSelectAllOption: true },
    },
    style: { width: 120 },
  },
  active_suppliers: {
    mode: 'select',
    treeCheckable: true,
    isMultiple: true,
    isTree: true,
    searchEnable: true,
    typeConfig: {
      multiple: { showSelectAllOption: true },
    },
    style: { width: 120 },
    popupProps: {
      popupStyle: { width: localPx2rem(200) },
      popupPlacement: 'bottom',
    },
  },
  suppliers: {
    mode: 'filter',
    treeCheckable: true,
    isMultiple: true,
    isTree: true,
    searchEnable: true,
    typeConfig: {
      multiple: { showSelectAllOption: true },
    },
    style: { width: 120 },
    popupProps: {
      getPopupContainer: undefined,
      popupStyle: { width: localPx2rem(200) },
      popupPlacement: 'bottom',
    },
  },
  currency: {
    mode: 'filter',
    saveKey: 'settle_currency',
    needOption: true,
    style: { width: 92 },
    popupProps: COMMON_POPUP_PROPS,
  },
  active_products: {
    mode: 'filter',
    isMultiple: true,
    needOption: true,
    style: {width: 92},
    popupProps: COMMON_POPUP_PROPS,
    typeConfig: MULTIPLE_TYPE,
  },
};

export {
  FILTER_OPTIONS,
};
